import styled from "styled-components";

interface ContainerProps {
    menuOpen?: boolean;
}

export const Container = styled.main<ContainerProps>`
    min-height: calc(100vh - 72px);
    transition: .5s all ease-in-out;
    display: flex;
    justify-content: center;
    flex: 1;

    @media(max-width: 575px) {
        opacity: ${props => props.menuOpen ? "0" : "1"};
    }

    @media(min-width: 1200px) {
        width: calc(100% - 250px);
    }
`;

export const Content = styled.div`
    width: 100%;
    max-width: 960px;
    padding: 15px;
    display: flex;
    flex-direction: column;
`;